import { createScopedInstanceAndLoader, getLanguage } from '@citrite/translate';
import { getVerticalSkin, VerticalSkin } from './verticalSkins';

const instance: any = createScopedInstanceAndLoader({
	namespace: 'projects-pilet',
	localesLoaderMap: {
		de: () => import('./locales/de.json'),
		en: () => import('./locales/en.json'),
		es: () => import('./locales/es.json'),
		fr: () => import('./locales/fr.json'),
		it: () => import('./locales/it.json'),
		ja: () => import('./locales/ja.json'),
		nl: () => import('./locales/nl.json'),
		'pt-BR': () => import('./locales/pt-BR.json'),
	},
	compatibilityJSON: 'v4',
});

instance.scopedi18nInstance.services.formatter?.add('lower', (value: string) => {
	return value.toLocaleLowerCase();
});

export const { LocalizationLoader } = instance;
export { getLanguage };

export const t = (key: string, options?: any): string =>
	instance.t(
		key,
		options?.context ? options : { context: getVerticalSkin(), ...options }
	);

export const ProjectsTitleStrings = new Map<VerticalSkin, Map<string, string>>([
	[
		VerticalSkin.Default,
		new Map([
			['de', 'Projekte'],
			['en', 'Projects'],
			['es', 'Proyectos'],
			['fr', 'Projets'],
			['it', 'Progetti'],
			['ja', 'プロジェクト'],
			['nl', 'Projecten'],
			['pt-BR', 'Projetos'],
		]),
	],
]);
